<div class="container mt-5">
  <div class="row justify-content-center align-items-center">
    <main role="main" class="col-6 text-center">
      <h1 class="mb-4">Permission denied</h1>
      <p class="fs-18" style="line-height: 1.6">
        Looks like you tried to access a page without the necessary permissions.
        If you think this is a mistake, kindly
        <a
          href="https://e2l.atlassian.net/servicedesk/customer/portal/8"
          target="_blank"
          >submit a help ticket</a
        >, and we'll get it sorted for you. Thanks for your understanding!
      </p>
    </main>
  </div>
</div>
